import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Icon } from '@mui/material';
import { useEffect } from 'react';
import { MessageSeverityEnum } from '../../../_common/enum/messageSeverity.enum';
import { IDropdownData } from '../../../_common/interface/dropdown/iDropdownData.interface';

const StyledMenu = styled((props: MenuProps) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
                ...theme.applyStyles('dark', {
                    color: 'inherit',
                }),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function AuctionNotificationType(params: { messageSeverityId: number | null, setMessageSeverityId: React.Dispatch<number | null>, onChange(messageSeverityId: MessageSeverityEnum | null): void, buttonStyle?: React.CSSProperties }) {

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event?.currentTarget);
    };

    const handleClose = (messageSeverityId: MessageSeverityEnum | null) => {
        setAnchorEl(null);
        params.setMessageSeverityId(messageSeverityId);
    };

    // useEffect(() => {
    //     params.onChange(params.messageSeverityId);
    // }, [params.messageSeverityId])

    return (
        <>
            <Button
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                style={params.buttonStyle ? params.buttonStyle : { "height": "24px", width: "100%" }}
                color={params.messageSeverityId == MessageSeverityEnum.Success ? "success" : params.messageSeverityId == MessageSeverityEnum.Warning ? "warning" : params.messageSeverityId == MessageSeverityEnum.Error ? "error" : "inherit"}
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
            >
                {params.messageSeverityId ? MessageSeverityEnum[params.messageSeverityId] : "Standard"}
            </Button>
            <StyledMenu
                id="demo-customized-menu"
                slotProps={{
                    list: {
                        'aria-labelledby': 'demo-customized-button',
                    },
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => (handleClose(null))}
            >
                <MenuItem onClick={() => { handleClose(MessageSeverityEnum.Success) }} disableRipple>
                    <Icon>check</Icon>
                    Success
                </MenuItem>
                <MenuItem onClick={() => { handleClose(MessageSeverityEnum.Warning) }} disableRipple>
                    <Icon>warning</Icon>
                    Warning
                </MenuItem>
                <MenuItem onClick={() => { handleClose(MessageSeverityEnum.Error) }} disableRipple>
                    <Icon>error</Icon>
                    Error
                </MenuItem>
                <MenuItem onClick={() => { handleClose(null) }} disableRipple>
                    <Icon>notifications</Icon>
                    Standard
                </MenuItem>
            </StyledMenu>
        </>
    );
}